import { load } from '@shopify/theme-sections';
import '../sections/coming-soon-collection';
import '../sections/slideshow-hero-new';
import '../sections/side-by-side';
import '../sections/product';

load('*');
